<template>
    <div class="crm-main-cont">
        <div class="search-box">
            <a-form :form="formSearch">
                <a-row :span="24">
                    <a-col :span="6">
                        <a-form-item label="主体名称" v-bind="layoutStyle2">
                            <a-input v-decorator="['ztmc']"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="上报类型" v-bind="layoutStyle2">
                            <a-select
                                    v-decorator="['type']"
                                    placeholder="请选择上报类型"
                            >
                                <a-select-option value="">
                                    所有
                                </a-select-option>
                                <a-select-option value="1">
                                    在线上报
                                </a-select-option>
                                <a-select-option value="2">
                                    模板上报
                                </a-select-option>
                                <a-select-option value="3">
                                    交换上报
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="处罚机关" v-bind="layoutStyle2">
                            <a-input v-decorator="['cfjg']"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="处罚时间" v-bind="layoutStyle2">
                            <a-range-picker @change="onChange" v-decorator="['ti']" style="width: 200px;"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="btns-group">
            <a-button type="primary" @click="handleSearch">
                搜索
            </a-button>
            <a-button @click="handleReset">
                重置
            </a-button>
            <a-button @click="changeDowning" style="color: #1890ff;border: solid 1px #1890ff;">
                导出数据
            </a-button>
            <!--<a-button @click="bathAdd" style="margin-left: 10px;color: #1890ff;border: solid 1px #1890ff;">
                导入
            </a-button>-->
        </div>
        <a-modal
                v-model="down2"
                title="导出数据"
                okText="确认"
                @ok="downDataExcel()"
                @cancel="closeDown2"
        >
            <a-form :form="formExcel">
                <a-form-item label="处罚时间" v-bind="layoutStyle2">
                    <a-range-picker
                            @change="onChangeSdate"
                            v-decorator="['sDate',{
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择处罚时间'
                                                }
                                            ]
                                        }]"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
        <div style="width: 100%;text-align: end;font-size: 14px;margin-bottom: -20px;padding: 5px;">
            <span style="">当前共{{sum}}处罚数据</span>
        </div>
        <a-table
                :rowClassName="TableClass"
                class="pjMode-list"
                :columns="columns"
                :dataSource="modeList"
                @change="handleTableChange"
                bordered
                :loading="loading"
                rowKey="id"
                :pagination="pagination"
        >
            <template slot="ctime" slot-scope="text, record">
                <div class="editable-row-operations">
                    {{text.split(".")[0]}}
                </div>
            </template>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a @click="() => showerr(record)">错误详情</a>
                    <a @click="() => show(record)">处罚详情</a>
                    <a @click="() => edit(record)">修改</a>

                </div>
            </template>
            <template slot="type" slot-scope="text, record">
                <span v-if="text == 'excel'">模板上报</span>
                <span v-if="text == 'manual'">在线上报</span>
                <span v-if="text == 'exchange'">交换上报</span>
            </template>
            <template slot="status" slot-scope="text">
                <span v-if="text == 1">提交</span>
                <span v-if="text == 2">检验通过</span>
                <span v-if="text == 4">上报国家</span>
                <span v-if="text == 0">保存</span>
                <span v-if="text == -1">检验未通过</span>
                <span v-if="text == -2">国家检验未通过</span>
            </template>
        </a-table>

        <a-drawer
                :title="titlecf"
                :width="650"
                @close="onClose"
                :visible="visible"
        >
            <!--            修改处罚-->
            <a-form v-if="editStatus && visible" :form="form2">
                <h2 style="text-align: center;">被处罚对象基础信息</h2>
                <a-row :gutter="16" class="from-top ">
                    <a-col :span="12">
                        <a-form-item label="行政相对人类别">
                            <a-select
                                    @change="handleChange2"
                                    v-decorator="[
                                    'xzxdrlb',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择行政相对人类别!'
                                            }
                                        ]
                                    }
                                    ]"
                                    placeholder="请选择行政相对人类别"
                            >
                                <a-select-option :value="1" :key="1">自然人</a-select-option>
                                <a-select-option :value="2" :key="2">企业</a-select-option>
                                <a-select-option :value="3" :key="3">社会组织</a-select-option>
                                <a-select-option :value="4" :key="4">事业单位</a-select-option>
                                <a-select-option :value="5" :key="5">政府机构</a-select-option>
                                <a-select-option :value="9" :key="9">个体工商户</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12"> <!--v-if="OtherZtlx == 1 || OtherZtlx == ''"-->
                        <a-form-item label="行政相对人名称">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'xzxdrmc',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写行政相对人名称!'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <div v-if="OtherZtlx == 2 || OtherZtlx == 3 || OtherZtlx == 4 || OtherZtlx == 5 || OtherZtlx == 9">
                    <a-row :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="统一社会信用代码">
                                <a-input maxlength="18" class="from-inputhei" @input="usccChange"
                                         v-decorator="[
                                    'USCC',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写统一社会信用代码!'
                                            },
                                            {
                                              validator: compareIDcard,
                                            }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="法定代表人">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                      'fddbr',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写法定代表人!'
                                              }
                                          ]
                                      }
                                  ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="from-top " v-if="OtherZtlx == 9 && isUscc2">
                        <a-col :span="12">
                            <a-form-item label="工商注册号">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                      'xzcfGsdj',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写工商注册号!'
                                              },
                                                {
                                                    pattern:/^[a-zA-Z\d]{0,20}$/,
                                                    message:'格式不正确，只能输入数字和字母，不能超过20位'
                                                }
                                          ]
                                      }
                                  ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="法定代表人证件类型">
                                <a-select @change="upChange"
                                          v-decorator="[
                                    'fddbrlx',
                                    {
                                          rules: [
                                              {

                                                  message: '请填写法定代表人证件类型!'
                                              }
                                          ]
                                      }
                                    ]"
                                          placeholder="请选择法定代表人证件类型"
                                >

                                    <a-select-option :value="'1'">
                                        身份证
                                    </a-select-option>
                                    <a-select-option :value="'2'">
                                        护照
                                    </a-select-option>
                                    <a-select-option :value="'3'">
                                        港澳居民来往内地通行证
                                    </a-select-option>
                                    <a-select-option :value="'4'">
                                        台湾居民来往大陆通行证
                                    </a-select-option>
                                    <a-select-option :value="'5'">
                                        外国人永久居留身份证
                                    </a-select-option>
                                    <a-select-option :value="'9'">
                                        其他
                                    </a-select-option>
                                    <a-select-option :value="''">
                                        空
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="法定代表人证件号码">
                                <a-input :maxlength="zjhmLen" class="from-inputhei"
                                         v-decorator="[
                                      'fddbrzjh',
                                       {
                                          rules: [
                                              {

                                                  message: '请填写法定代表人证件号码!'
                                              }
                                          ]
                                      }
                                  ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!--（修改）选择企业再选择其他-->
                    <a-row v-if="upOtherZjlx || this.upZjlx == 9" :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="法定代表人证件类型其他类型说明">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                      'fddbrLxOther',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写法定代表人证件类型其他类型说明!'
                                              },
                                              {
                                                  max:50,
                                                  message: '最多填写50个字'
                                              }
                                          ]
                                      }
                                  ]"
                                         placeholder="请填写法定代表人证件类型其他类型说明，最多50字"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>
                <div v-if="OtherZtlx == 1">
                    <a-row :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="证件类型">
                                <a-select @change="upChange"
                                          v-decorator="[
                                    'zjlx',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择证件类型!'
                                            }
                                        ]
                                    }
                                    ]"
                                          placeholder="证件类型"
                                >
                                    <a-select-option value="1">
                                        身份证
                                    </a-select-option>
                                    <a-select-option value="2">
                                        护照
                                    </a-select-option>
                                    <a-select-option value="3">
                                        港澳居民来往内地通行证
                                    </a-select-option>
                                    <a-select-option value="4">
                                        台湾居民来往大陆通行证
                                    </a-select-option>
                                    <a-select-option value="5">
                                        外国人永久居留身份证
                                    </a-select-option>
                                    <a-select-option value="9">
                                        其他
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="证件号码">
                                <a-input :maxlength="zjhmLen" class="from-inputhei"
                                         v-decorator="[
                                      'zjhm',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写证件号码!'
                                              }
                                          ]
                                      }
                                  ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <!--(修改) 选择自然人再选择其他-->
                    <a-row v-if="upOtherZjlx || this.upZjlx == 9" :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="自然人证件类型其他类型说明">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                      'zjlxOther',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写自然人证件类型其他类型说明!'
                                              },
                                              {
                                                  max:50,
                                                  message: '最多填写50个字'
                                              }
                                          ]
                                      }
                                  ]"
                                         placeholder="请填写自然人证件类型其他类型说明，最多50字"
                                />
                            </a-form-item>
                        </a-col>
                        <!--                        <a-col :span="12">-->
                        <!--                            <a-form-item label="法定代表人证件类型其他类型说明">-->
                        <!--                                <a-input class="from-inputhei"-->
                        <!--                                         v-decorator="[-->
                        <!--                                      'fddbrLxOther',-->
                        <!--                                      {-->
                        <!--                                          rules: [-->
                        <!--                                              {-->
                        <!--                                                  required: true,-->
                        <!--                                                  message: '请填写法定代表人证件类型其他类型说明!'-->
                        <!--                                              },-->
                        <!--                                              {-->
                        <!--                                                  max:50,-->
                        <!--                                                  message: '最多填写50个字'-->
                        <!--                                              }-->
                        <!--                                          ]-->
                        <!--                                      }-->
                        <!--                                  ]"-->
                        <!--                                         placeholder="请填写法定代表人证件类型其他类型说明，最多50字"-->
                        <!--                                />-->
                        <!--                            </a-form-item>-->
                        <!--                        </a-col>-->
                    </a-row>
                </div>

                <h2 style="margin-top: 5px;text-align: center;">处罚信息</h2>
                <a-row :gutter="16" class="from-top">
                  <a-col :span="12">
                    <a-form-item label="行政处罚决定文书名称">
                      <a-input class="from-inputhei" maxlength="64"
                               v-decorator="[
                                    'cfjdwsmc',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写行政处罚决定文书名称!'
                                            }
                                        ]
                                    }
                                ]"
                      />
                    </a-form-item>
                  </a-col>
                    <a-col :span="12">
                        <a-form-item label="行政处罚决定文书号">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'wsh',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写行政处罚决定文书号!'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
              <a-row :gutter="16" class="from-top">
                    <a-col :span="12">
                        <a-form-item label="违法类型">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'wflx',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写违法类型!'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top">
                    <a-col :span="24">
                        <a-form-item label="处罚依据">
                            <a-textarea maxlength="2048"
                                        v-decorator="[
                            'cfyj',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请填写处罚依据'
                                    }
                                ]
                            }
                        ]"
                                        :rows="4"
                                        placeholder="请填写处罚依据,最多2048字"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="textTop">
                    <a-col :span="24">
                        <a-form-item label="违法事实">
                            <a-textarea maxlength="5000"
                                        v-decorator="[
                            'wfss',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请填写违法事实'
                                    }
                                ]
                            }
                        ]"
                                        :rows="4"
                                        placeholder="请填写违法事实，最多5000字"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="textTop">
                    <a-col :span="12">
                        <a-form-item label="处罚类别">
                            <a-select
                                    v-decorator="[
                                    'cflb',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择处罚类别!'
                                            }
                                        ]
                                    }
                                    ]"
                                    placeholder="请选择处罚类别"
                                    @change="handleChange1"
                            >
                                <a-select-option value="1">
                                    警告
                                </a-select-option>
                                <a-select-option value="2">
                                    罚款
                                </a-select-option>
                                <a-select-option value="3">
                                    没收违法所得
                                </a-select-option>
                                <a-select-option value="4">
                                    没收非法财物
                                </a-select-option>
                                <a-select-option value="5">
                                    责令停产停业
                                </a-select-option>
                                <a-select-option value="6">
                                    暂扣或者吊销许可证
                                </a-select-option>
                                <a-select-option value="7">
                                    暂扣或者吊销执照
                                </a-select-option>
                                <a-select-option value="8">
                                    行政拘留
                                </a-select-option>
                              <a-select-option value="10">
                                通报批评
                              </a-select-option>
                              <a-select-option value="11">
                                降低资质等级
                              </a-select-option>
                              <a-select-option value="12">
                                限制开展生产经营活动
                              </a-select-option>
                              <a-select-option value="13">
                                责令关闭
                              </a-select-option>
                              <a-select-option value="14">
                                限制从业
                              </a-select-option>
                                <a-select-option value="9">
                                    其他
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12" v-if="otherDF == 9">
                        <a-form-item label="其他类别说明">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                      'otherDesc',
                                      {
                                          rules: [
                                              {
                                                  required: true,
                                                  message: '请填写其他类别说明!'
                                              }
                                          ]
                                      }
                                  ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top from-top2">
                    <a-col :span="24">
                        <a-form-item label="处罚内容">
                            <a-textarea maxlength="4000"
                                        v-decorator="[
                            'cfnr',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请填写处罚内容'
                                    }
                                ]
                            }
                        ]"
                                        :rows="4"
                                        placeholder="请填写处罚内容，最多4000字"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="textTop from-top">
                    <a-col :span="12" v-if="otherDF == 2">
                        <a-form-item label="罚款金额（万元）">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'cfje',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写处罚金额!'
                                            },
                                            {
                                              validator: compareNUM,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12" v-if="otherDF != 2">
                        <a-form-item label="罚款金额（万元）">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'cfje',
                                    {
                                        rules: [
                                            {
                                                required: false,
                                                message: '请填写处罚金额!'
                                            },
                                            {
                                              validator: compareNUM,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12" v-if="otherDF == 3 || otherDF == 4">
                        <a-form-item label="没收违法所得、没收非法财物的金额（万元）">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'msje',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写没收违法所得、没收非法财物的金额（万元）!'
                                            },
                                            {
                                              validator: compareNUM,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12" v-if="otherDF != 3 && otherDF != 4">
                        <a-form-item label="没收违法所得、没收非法财物的金额（万元）">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'msje',
                                    {
                                        rules: [
                                            {
                                              validator: compareNUM,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <div v-if="otherDF == 6 || otherDF == 7">
                    <a-row :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="暂扣或吊销证照名称及编号">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                    'zkbh',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写没暂扣或吊销证照名称及编号!'
                                            }
                                        ]
                                    }
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>
                <div v-if="otherDF != 6 && otherDF != 7">
                    <a-row :gutter="16" class="from-top ">
                        <a-col :span="12">
                            <a-form-item label="暂扣或吊销证照名称及编号">
                                <a-input class="from-inputhei"
                                         v-decorator="[
                                    'zkbh'
                                ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>
                <a-row :gutter="16" class="from-top ">
                    <a-col :span="12">
                        <a-form-item label="处罚决定日期">
                            <a-date-picker @change="onChangeTime3"
                                           :disabledDate="disabledDate2"
                                           v-decorator="[
                                    'jdrq',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择处罚决定日期!'
                                            }
                                        ]
                                    }
                                    ]
              "/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="是否已修复">
                            <a-select
                                    v-decorator="[
                                    'sfxf',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择是否已修复!'
                                            }
                                        ]
                                    }
                                    ]"
                                    placeholder="请选择是否已修复"
                                    disabled
                            >
                                <a-select-option :value="0">
                                    否
                                </a-select-option>
                                <a-select-option :value="1">
                                    是
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top ">
                    <a-col :span="12">
                        <a-form-item label="处罚有效期">
                            <a-date-picker
                                    style="width:60%"
                                    @change="onChangeTime1"
                                    v-decorator="[
                                    'cfyxq',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择处罚有效期!'
                                            }
                                        ]
                                    }
                                    ]
              "/>
                            <a-button @click="changeYXQ2" style="margin-left: 40px;">长期</a-button>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="公示截止期">
                            <a-date-picker
                                    style="width:60%"
                                    @change="onChangeTime2"
                                    v-decorator="[
                                    'cfjzq',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择公示截止期!'
                                            },
                                            {
                                                validator: publicityValidator2
                                            }
                                        ]
                                    }
                                    ]
              "/>
<!--                            <a-button @click="changeJZQ1" style="margin-left: 40px;">长期</a-button>-->
<!--                            <a-button size="small" @click="changeAddOneYear2" style="margin-left: 10px;height: 32px;width: 40px;">1年</a-button>-->
                            <a-button size="small" @click="changeAddThreeYear2" style="margin-left: 10px;height: 32px;width: 40px;">3年</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top ">
                    <a-col :span="12">
                        <a-form-item label="处罚机关">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'CFJG',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写处罚机关!'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="处罚机关统一社会信用代码">
                            <a-input maxlength="18" class="from-inputhei"
                                     v-decorator="[
                                    'CF_USCC',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写处罚机关统一社会信用代码!'
                                            },
                                            {
                                              validator: compareIDcard,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top ">
                    <a-col :span="12">
                        <a-form-item label="数据来源单位">
                            <a-input class="from-inputhei"
                                     v-decorator="[
                                    'LYDW',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写数据来源单位!'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="数据来源单位统一社会信用代码">
                            <a-input maxlength="18" class="from-inputhei"
                                     v-decorator="[
                                    'LY_USCC',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写数据来源单位统一社会信用代码!'
                                            },
                                            {
                                              validator: compareIDcard,
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16" class="from-top" style="margin-bottom: 77px;">
                    <a-col :span="24">
                        <a-form-item label="备注">
                            <a-textarea maxlength="512"
                                        v-decorator="['bz']"
                                        :rows="4"
                                        placeholder="请填写备注，最多512字"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="submit-btn">
                    <a-button @click="updatePjMode(1,15)" type="primary"
                              :loading="uploading"
                    >
                        {{uploading ? '正在处理' : '修改' }}
                    </a-button
                    >
                </div>
            </a-form>
        </a-drawer>

        <a-drawer
                title="处罚异常数据批量导入"
                :width="650"
                @close="onClose2"
                :visible="visible2"
        >

            <a-form>
                <a-row>
                    <a-col :span="24">
                        <a-form-item label="文件" v-bind="layoutStyle">
                            <a-upload
                                    accept=".xls"
                                    :fileList="fileList"
                                    :remove="handleRemove"
                                    :beforeUpload="beforeUpload"
                            >
                                <a-button>
                                    <a-icon type="upload"/>
                                    选择文件
                                </a-button>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row style="margin-top: 30px">
                    <span style="color:red">单个导入文件不超过1000条数据</span>
                </a-row>
                <a-row style="margin-top: 15px;">
                    <span v-if="zts > 0">总插入{{zts}}条记录，成功{{cgs}}条，失败{{sbs}}条。</span>
                    <span v-if="sbs > 0"><a :href="showFile(excelName)">点击下载失败记录</a></span>
                </a-row>
                <div class="submit-btn">
                    <a-button
                            type="primary"
                            @click="handleUpload"
                            :disabled="fileList.length === 0"
                            :loading="uploading"
                    >
                        {{uploading ? '正在处理' : '开始导入' }}
                    </a-button>
                </div>
            </a-form>
        </a-drawer>

        <!--        处罚详情-->
        <a-drawer
                @close="cancelComform2"
                :visible="comform1"
                :title="Title2"
                width="900px"
                :footer="null"
                :zIndex="5"
        >
            <div style="text-align: right;">
                <!-- <span>数据录入时间：{{createTime}}</span> -->
            </div>
            <h2 style="text-align: center;">被处罚对象基础信息</h2>
            <table border style="width: 100%; text-align: center; margin-top: 15px;">
                <tr>
                    <td class="leftTd bc">行政相对人名称:</td>
                    <td class="rightTd">{{datass.xzxdrmc}}</td>
                    <td class="leftTd bc">行政相对人类别:</td>
                    <td class="rightTd">
                        <span v-if="datass.ztId == 1">自然人</span>
                        <span v-else-if="datass.ztId == 2">企业</span>
                        <span v-else-if="datass.ztId == 3">社会组织</span>
                        <span v-else-if="datass.ztId == 4">事业单位</span>
                        <span v-else-if="datass.ztId == 5">政府机构</span>
                        <span v-else-if="datass.ztId == 9">个体工商户</span>
                        <span v-else>{{datass.ztId}}</span>
                    </td>
                </tr>
                <tr v-if="datass.ztId == 2 || datass.ztId == 3 || datass.ztId == 4 || datass.ztId == 5 || datass.ztId == 9">
                    <td class="leftTd bc">统一社会信用代码:</td>
                    <td class="rightTd">{{datass.uscc}}</td>
                    <td class="leftTd bc">法定代表人:</td>
                    <td class="rightTd">
                        {{datass.fddbr}}
                    </td>
                </tr>
                <tr v-if="datass.ztId == 2 || datass.ztId == 3 || datass.ztId == 4 || datass.ztId == 5 || datass.ztId == 9">
                    <td class="leftTd bc">法定代表人证件类型:</td>
                    <td class="rightTd">
                        <span v-if="datass.fddbrlx == 1">身份证</span>
                        <span v-else-if="datass.fddbrlx == 2">护照</span>
                        <span v-else-if="datass.fddbrlx == 3">港澳居民来往内地通行证</span>
                        <span v-else-if="datass.fddbrlx == 4">台湾居民来往大陆通行证</span>
                        <span v-else-if="datass.fddbrlx == 5">外国人永久居留身份证</span>
                        <span v-else-if="datass.fddbrlx == 9">其他-{{datass.fddbrLxOther}}</span>
                        <span v-else>{{datass.fddbrlx}}</span>
                    </td>
                    <td class="leftTd bc">法定代表人证件号码:</td>
                    <td class="rightTd">
                        {{datass.fddbrzjh}}
                    </td>
                </tr>
                <tr v-if="datass.ztId == 9 && datass.uscc == '00000000000000000X'">
                    <td class="leftTd bc">工商注册号</td>
                    <td class="rightTd">{{datass.xzcfGsdj}}</td>
                    <td class="leftTd bc"></td>
                    <td class="rightTd"></td>
                </tr>
                <tr v-if="datass.ztId == 1">
                    <td class="leftTd bc">证件类型:</td>
                    <td class="rightTd">
                        <span v-if="datass.zjlx == 1">身份证</span>
                        <span v-else-if="datass.zjlx == 2">护照</span>
                        <span v-else-if="datass.zjlx == 3">港澳居民来往内地通行证</span>
                        <span v-else-if="datass.zjlx == 4">台湾居民来往大陆通行证</span>
                        <span v-else-if="datass.zjlx == 5">外国人永久居留身份证</span>
                        <span v-else-if="datass.zjlx == 9">其他-{{datass.zjlxOther}}</span>
                        <span v-else>{{datass.zjlx}}</span>
                    </td>
                    <td class="leftTd bc">证件号码:</td>
                    <td class="rightTd">
                        {{datass.uscc}}
                    </td>
                </tr>
            </table>

            <h2 style="text-align: center;margin-top: 40px;">处罚信息</h2>
            <table border style="width: 100%; text-align: center; margin-top: 15px;">
              <tr>
                <td class="leftTd2 bc">
                  行政处罚决定文书名称:
                </td>
                <td colspan="3" class="rightTd2">
                  {{datass.cfjdwsmc}}
                </td>
              </tr>
                <tr>
                    <td class="leftTd2 bc">
                        行政处罚决定文书号:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.wsh}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        违法类型:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.wflx}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚依据:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfyj}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        违法事实:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.wfss}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚类别:
                    </td>
                    <td colspan="3" class="rightTd2">
                        <span v-if="datass.cflb == 1">警告</span>
                        <span v-else-if="datass.cflb == 2">罚款</span>
                        <span v-else-if="datass.cflb == 3">没收违法所得</span>
                        <span v-else-if="datass.cflb == 4">没收非法财物</span>
                        <span v-else-if="datass.cflb == 5">责令停产停业</span>
                        <span v-else-if="datass.cflb == 6">暂扣或者吊销许可证</span>
                        <span v-else-if="datass.cflb == 7">暂扣或者吊销执照</span>
                        <span v-else-if="datass.cflb == 8">行政拘留</span>
                      <span v-else-if="datass.cflb == 10">通报批评</span>
                      <span v-else-if="datass.cflb == 11">降低资质等级</span>
                      <span v-else-if="datass.cflb == 12">限制开展生产经营活动</span>
                      <span v-else-if="datass.cflb == 13">责令关闭</span>
                      <span v-else-if="datass.cflb == 14">限制从业</span>
                        <span v-else-if="datass.cflb == 9">其他</span>
                        <span v-else>{{datass.cflb}}</span>
                    </td>
                </tr>
                <tr v-if="datass.cflb == 9">
                    <td class="leftTd2 bc">
                        其他类别说明:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.otherDesc}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚内容:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfnr}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        罚款金额（万元）:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfje}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        没收违法所得、没收非法财物的金额（万元）:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.msje}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        暂扣或吊销证照名称及编号:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.zkbh}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚决定日期:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.jdrq}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        是否已修复:
                    </td>
                    <td colspan="3" class="rightTd2">
                        <span v-if="datass.sfxf == 1">是</span>
                        <span v-else-if="datass.sfxf == 0">否</span>
                        <span v-else>{{datass.sfxf}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚有效期:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfyxq}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        公示截止期:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfjzq}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚机关:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cfjg}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        处罚机关统一社会信用代码:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.cf_USCC}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        数据来源单位:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.lydw}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        数据来源单位统一社会信用代码:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.ly_USCC}}
                    </td>
                </tr>
                <tr>
                    <td class="leftTd2 bc">
                        备注:
                    </td>
                    <td colspan="3" class="rightTd2">
                        {{datass.bz}}
                    </td>
                </tr>
            </table>

        </a-drawer>

        <a-modal
                v-model="errorView"
                title="错误详情"
                :footer="null"
                width="800px"
        >
            <a-table
                    :rowClassName="TableClass"
                    :columns="errorColumns"
                    :dataSource="errorList"
                    @change="errhandleTableChange"
                    bordered
                    :loading="errorloading"
                    rowKey="id"
                    :pagination="errorpagination"
            >
                <template slot="faild" slot-scope="text, record">
                    <span>{{record.column_name}}({{record.column_comment}})</span>

                </template>
                <template slot="ctime" slot-scope="text">
                    <span>{{ timeToDate(text) }}</span>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>
<script>


    import moment from 'moment';
    import {
        getXzcfList,
        updateXzcf,
        findONE,
        getErrorList,
        importData
    } from "@/api/publicityData/xzcfCityErrManager";
    import {getSource} from "@/api/publicityData/xzxkManager";

    const columns = [
        /*{
          title: "上报类型",
          dataIndex: "type",
          width: 120,
          scopedSlots: { customRender: "type" },
        },*/
        {
            title: "主体名称",
            dataIndex: "xzxdrmc",
            width: 200,
            scopedSlots: {customRender: "xzxdrmc"},
        },
        {
            title: "处罚文书号",
            dataIndex: "wsh",
            width: 200,
            scopedSlots: {customRender: "wsh"},
        },
        {
            title: "处罚机关",
            dataIndex: "cfjg",
            width: 200,
            scopedSlots: {customRender: "cfjg"},
        },
        {
            title: "处罚日期",
            dataIndex: "jdrq",
            width: 150,
            scopedSlots: {customRender: "jdrq"},
        },
        {
            title: "数据提交时间",
            dataIndex: "ctime",
            width: 200,
            scopedSlots: {customRender: "ctime"},
        },
        {
            title: "提交人",
            dataIndex: "cname",
            width: 150,
            scopedSlots: {customRender: "cname"},
        },
        /*{
            title: "数据状态",
            dataIndex: "status",
            width: 150,
            scopedSlots: { customRender: "status" },
        },*/
        /*
        {
          title: "提交时间",
          dataIndex: "ctime",
          width: 200,
          scopedSlots: { customRender: "ctime" },
        },*/
        {
            title: "操作",
            dataIndex: "operation",
            width: 180,
            scopedSlots: {customRender: "operation"},
        }
    ];

    const errorColumns = [
        {
            title: "错误字段",
            dataIndex: "column_name",
            scopedSlots: {customRender: "faild"},
        },
        {
            title: "错误原因",
            dataIndex: "error_reason",
            scopedSlots: {customRender: "ename"},
        },
        {
            title: "评估时间",
            dataIndex: "analysis_time",
            scopedSlots: {customRender: "ctime"},
        }
    ];
    export default {
        name: "InfoPunishment",
        data() {
            return {
                createTime: "1979-01-01 00:00:00",
                sum: 0,
                loading: false,
                errorloading: false,
                errorView: false,
                uploading: false,
                visible2: false,
                infoSpinning: true,
                infoVisible: false,
                fileList: [],
                logList: [],
                titlecf: "",
                zts: 0,
                cgs: 0,
                sbs: 0,
                excelName: "",
                pattern: "",
                down2: false,
                otherDF: "",
                OtherZtlx: "",
                datass: "",
                cfyxq1: "",
                cfjzq1: "",
                jdrq1: "",
                unId: null,
                comform: false,
                comTitle: "",
                comform1: false,
                Title2: "",
                comform2: false,
                comTitle2: "",
                comform3: false,
                comTitle3: "",
                comform4: false,
                comTitle4: "",
                otherZjlx: false,
                upOtherZjlx: false,
                isUscc2: false,
                zjlx: 0,
                upZjlx: 0,
                zjhmLen: 18,
                columns,
                errorColumns,
                errorList: [],
                modeName: "",
                form: this.$form.createForm(this),
                form2: this.$form.createForm(this),
                form6: this.$form.createForm(this),
                formSearch: this.$form.createForm(this),
                formExcel: this.$form.createForm(this),
                editStatus: false,
                visible: false,
                title: "添加用户",
                fEvaTitle: "新增一级指标",
                delId: "",
                forEva: "",
                qyFile: "",
                tzFile: "",
                otherFile: "",
                startTime: "",
                endTime: "",
                editMode: "",
                layoutStyle: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 16
                    }
                },
                layoutStyle2: {
                    labelCol: {
                        span: 6
                    },
                    wrapperCol: {
                        span: 17
                    }
                },
                layoutStyle3: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 17
                    }
                },
                modeList: [],
                search: {
                    ztmc: "",
                    type: "",
                    cfjg: "",
                    startTime: "",
                    endTime: "",
                    pageNum: 1
                },
                tempNo: {
                    uscc: "",
                    ztmc: "",
                },
                pagination: {
                    total: 40,
                    current: 1,
                    pageSize: 20
                },
                errorpagination: {
                    id: '',
                    uscc: '',
                    wsh: '',
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                editItem: "",
                editEva: "",
                role: "",
                searchZTMCList: [],
                fEva: false,
                authAccount: "",
                editAuthId: "",
                authList: [],
                operationIdList: [],
                operationCodeList: [],
                ansearchList2: [],
                chosene: "",
                cfid: "",
                cid: "",
                startTime1: "",
                endTime1: ""
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.closeAll();
                vm.loading = true;
                let status = "-1,";
                vm.search.status = status;
                vm.loading = true;
                getXzcfList({ztmc: "", type: "", cfjg: "", startTime: "", endTime: '', pageNum: 1, status: status})
                    .then(res => {
                        vm.$ajaxAfter(res).then(() => {
                            vm.modeList = res.data.data.page.list;
                            vm.role = res.data.data.role;
                            Object.assign(vm.pagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                current: res.data.data.page.pageNum
                            });
                            vm.sum = res.data.data.page.total;
                            vm.loading = false;
                            vm.getSources();
                        });
                    })
                    .catch(() => {
                        vm.$message.error("服务器出错！请稍后再试!");
                        vm.$Progress.fail();
                    });
            });

        },
        methods: {

            onClose2() {
                this.visible2 = false;
                this.fileList = []
                this.sbs = 0
                this.cgs = 0
                this.zts = 0
                this.excelName = ""
            },

            selectChange(value, option) {
                if (value == 9) {
                    this.zjhmLen = false;
                    this.zjlx = 9;
                    this.otherZjlx = true;
                } else {
                    this.zjhmLen = 18;
                    this.zjlx = 0;
                    this.form.setFieldsValue({
                        "fddbrLxOther": "",
                        "zjlxOther": ""
                    })
                    this.otherZjlx = false;
                }
            },
            upChange(value, option) {
                if (value == 9) {
                    this.zjhmLen = false;
                    this.upZjlx = 9;
                    this.upOtherZjlx = true;
                } else {
                    this.zjhmLen = 18;
                    this.upZjlx = 0;
                    this.upOtherZjlx = false;
                    this.$nextTick(() => {
                        this.form2.setFieldsValue({
                            "fddbrLxOther": "",
                            "zjlxOther": ""
                        })
                    })
                }
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList
            },
            showFile(filePath) {
                filePath = '/img/' + filePath;
                return '/creditapi/downloadFile/download?fileName=' + filePath
            },

            beforeUpload(file) {
                this.fileList = [file]
                var fileName = this.fileList[0].name.substring(this.fileList[0].name.length - 4)
                if (fileName !== ".xls") {
                    const newFileList = this.fileList.slice();
                    newFileList.splice(0, 1);
                    this.fileList = newFileList
                    this.$message.error("只能上传后缀为.xls的Excel文件，请重新上传！")
                }
                return false;
            },

            handleUpload() {
                this.uploading = true
                const {fileList} = this;
                const formData = new FormData();
                fileList.forEach((file) => {
                    formData.append('files', file);
                });
                importData(formData).then(res => {
                    if (res.data.success == "TRUE") {
                        this.$message.success('导入成功,数据无错');
                        this.visible2 = false;
                        this.initPjModeList();
                        this.uploading = false;
                    }
                    if (res.data.success === "FALSE") {
                        console.log(res.data.data);
                        this.sbs = res.data.data.sbs;
                        this.zts = res.data.data.zts;
                        this.cgs = res.data.data.cgs;
                        if (res.data.data.sbs > 0) {
                            this.excelName = res.data.data.fileName
                        }

                        this.initPjModeList();
                        this.uploading = false;
                        this.$message.warning(res.data.message)
                    }

                }).catch(error => {
                    this.$message.error("上传错误，请重新上传！");
                    this.uploading = false
                })
            },

            bathAdd() {
                this.visible2 = true;
                this.sbs = 0
                this.zts = 0
                this.cgs = 0
            },

            downDataExcel() {
                let values = this.formExcel.getFieldsValue();

                if (this.startTime1 == undefined || this.startTime1 == "" || this.endTime1 == undefined || this.endTime1 == "") {
                    this.$message.info("请选择处罚时间！");
                    return;
                }

                //判断开始时间和结束时间的时间间隔
                let startDate = new Date(this.startTime1);
                let endDate = new Date(this.endTime1);
                let date = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24)
                if (date > 1) {
                    this.$message.error("开始时间到结束时间间隔不超过1天！");
                    return;
                }

                window.open(
                    "/creditapi/punishment/downloadExchangeExcel?startTime=" +
                    this.startTime1 +
                    "&endTime=" +
                    this.endTime1
                );

                this.down2 = false
                this.startTime1 = ""
                this.endTime1 = ""
                this.formExcel.resetFields();

            },

            changeDowning() {
                this.down2 = true
            },
            closeDown2() {
                this.down2 = false;
            },

            closeAll() {
                this.hongVis = false;
                this.heiVis = false;
                this.comform = false;
                this.visible = false;
                this.comform1 = false;
                this.visible2 = false;
                this.infoVisible = false;
            },
            timeToDate(timestamp) {
                var date = new Date(timestamp);
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                        ? "0" + (date.getMonth() + 1)
                        : date.getMonth() + 1) + "-";
                var D = date.getDate() + " ";
                var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
                var m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
                var s = (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
                return Y + M + D + h + m + s;
            },
            moment,
            //点击搜索
            handleSearch() {
                let values = this.formSearch.getFieldsValue();
                Object.assign(this.search, {
                    ztmc: values.ztmc || "",
                    type: values.type,
                    cfjg: values.cfjg || "",
                    startTime: this.startTime,
                    endTime: this.endTime,
                    pageNum: 1
                });
                this.initPjModeList();
            },
            //点击重置
            handleReset() {
                this.formSearch.resetFields();
                this.formSearch.setFieldsValue({
                    ztmc: "",
                    type: "",
                    cfjg: "",
                });
                Object.assign(this.search, {
                    ztmc: "",
                    type: "",
                    cfjg: "",
                    startTime: "",
                    endTime: "",
                    pageNum: 1
                });
                this.initPjModeList();
            },
            //初始化用户数据
            initPjModeList() {
                this.loading = true;
                getXzcfList(this.search)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.modeList = res.data.data.page.list;
                            Object.assign(this.pagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                current: res.data.data.page.pageNum
                            });
                            this.sum = res.data.data.page.total;
                            this.loading = false;
                        });
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                        this.loading = false;
                    });
            },
            getSources() {
                getSource()
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            if (res.data.success == "FALSE") {
                                this.$message.error(res.data.message);
                            } else if (res.data.success == "TRUE") {
                                this.dept = res.data.data.dept;
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            },
            handleTableChange(page) {
                this.search.pageNum = page.current;
                this.initPjModeList();
            },
            edit(mode) {
                this.titlecf = "行政处罚修改";
                findONE(mode.id)
                    .then(res => {
                        if (res.data.success == 'FALSE') {
                            this.$message.error(res.data.message)
                        } else {
                            mode = res.data.data.one
                            this.editMode = res.data.data.one;
                            this.editItem = mode;
                            this.visible = true;
                            this.jdrq1 = mode.jdrq;
                            this.cfyxq1 = mode.cfyxq;
                            this.cfjzq1 = mode.cfjzq;
                            this.editStatus = true;
                            this.OtherZtlx = mode.ztId;
                            this.otherDF = mode.cflb;
                            this.unId = mode.unId;
                            if (mode.zjlx == 9 || mode.fddbrlx == 9) {
                                this.upOtherZjlx = true;
                            } else {
                                this.upOtherZjlx = false;
                            }
                            if (mode.ztId == 9 && mode.uscc == "00000000000000000X") {
                                this.isUscc2 = true;
                            } else {
                                this.isUscc2 = false;
                            }
                            setTimeout(() => {
                                this.form2.setFieldsValue({
                                    CFJG: mode.cfjg,
                                    CF_USCC: mode.cf_USCC,
                                    LYDW: mode.lydw || "",
                                    LY_USCC: mode.ly_USCC || "",
                                    bz: mode.bz || "",
                                    cfje: mode.cfje || "",
                                    cfjzq: moment(mode.cfjzq, "YYYY-MM-DD"),
                                    cflb: mode.cflb,
                                    cfnr: mode.cfnr || "",
                                    cfyj: mode.cfyj || "",
                                    USCC: mode.uscc || "",
                                    cfyxq: moment(mode.cfyxq, "YYYY-MM-DD"),
                                    fddbr: mode.fddbr || "",
                                    fddbrlx: mode.fddbrlx,
                                    fddbrzjh: mode.fddbrzjh || "",
                                    jdrq: moment(mode.jdrq, "YYYY-MM-DD"),
                                    msje: mode.msje || "",
                                    otherDesc: mode.otherDesc || "",
                                    sfxf: mode.sfxf,
                                    wflx: mode.wflx || "",
                                    wfss: mode.wfss || "",
                                    wsh: mode.wsh || "",
                                    xzxdrlb: mode.ztId,
                                    xzxdrmc: mode.xzxdrmc || "",
                                    // xzxdrmc1: mode.xzxdrmc || "",
                                    zjhm: mode.uscc || "",
                                    zjlx: mode.zjlx,
                                    zkbh: mode.zkbh || "",
                                    zjlxOther: mode.zjlxOther,
                                    fddbrLxOther: mode.fddbrLxOther,
                                    xzcfGsdj: mode.xzcfGsdj,
                                  cfjdwsmc:mode.cfjdwsmc
                                });
                            }, 500);
                        }
                    })
                    .catch(() => {
                        this.$message.error('服务器出错，请稍后重试!')
                    })

            },
            usccChange() {
                let value = this.form2.getFieldValue("USCC");
                if (value == "00000000000000000X") {
                    this.isUscc2 = true;
                } else {
                    this.isUscc2 = false;
                }
            },
            updatePjMode(status, stype) {
                // if(this.upZjlx == 9){
                this.form2.validateFields((err, values) => {
                    if (!err) {
                        this.uploading = true;
                        values.id = this.editItem.id;
                        values.cfyxq = this.cfyxq1;
                        values.cfjzq = this.cfjzq1;
                        values.jdrq = this.jdrq1;
                        values.status = status;
                        values.stype = stype;
                        values.unId = this.unId;//唯一标识
                        /*if (values.xzxdrlb != 1) {
                            values.xzxdrmc = values.xzxdrmc1
                        }*/
                        if (values.zjlx == 1 && values.zjhm.length != 18) {
                            this.$message.error("身份证号必须等于18位");
                            this.uploading = false;
                            return;
                        }
                        if (values.xzxdrlb == 1 && values.zjhm.length != 18) {
                            this.uploading = false;
                            this.$message.error("请输入正确的身份证号码");
                            return;
                        }
                        /*if (values.xzxdrlb == 2 && values.fddbrzjh.length != 18) {
                            this.uploading = false;
                            this.$message.error("请输入正确的身份证号码");
                            return;
                        }*/
                        updateXzcf(values)
                            .then(res => {
                                this.$ajaxAfter(res).then(() => {
                                    this.$message.success("修改成功！请前往上报页面查看");
                                    this.initPjModeList();
                                    this.editStatus = false;
                                    this.visible = false;
                                    this.hongheiInfo = false;
                                    this.uploading = false;
                                });
                            })
                            .catch(() => {
                                this.$message.error("服务器出错！请稍后再试!");
                                this.uploading = false;
                            });
                    }
                });
            },

            compareIDcard2(rule, value, callback) {
                let reg = /^[0-9A-Za-z]{18}$/;
                if (value && !reg.test(value)) {
                    this.hongheiInfo = false;
                    callback('请填写18位社会统一信用代码');
                } else {
                    /*getQyData(value)
                        .then(res => {
                            this.$ajaxAfter(res).then(() => {
                                if (res.data.success == 'TRUE') {
                                    this.hUscc = value;
                                    this.hongheiInfo = true;
                                    this.hongInfo = res.data.data.hong;
                                    this.heiInfo = res.data.data.hei;
                                }
                            })
                        })*/
                    callback();
                }
            },

            compareIDcard(rule, value, callback) {
                let reg = /^[0-9A-Za-z]{18}$/;
                if (value && !reg.test(value)) {
                    callback('请填写18位社会统一信用代码');
                } else {
                    callback();
                }
            },
            //改变时间
            onChange(date, dateString) {
                this.startTime = dateString[0]
                this.endTime = dateString[1]
            },
            onChangeTime1(date, dateString) {
                this.cfyxq1 = dateString
            },
            onChangeTime2(date, dateString) {
                this.cfjzq1 = dateString
            },
            onChangeTime3(date, dateString) {
                this.jdrq1 = dateString
            },


            onChangeSdate(date, dateString) {
                this.startTime1 = dateString[0]
                this.endTime1 = dateString[1]
            },

            show(record) {
                findONE(record.id)
                    .then(res => {
                        if (res.data.success == 'FALSE') {
                            this.$message.error(res.data.message)
                        } else {
                            this.datass = res.data.data.one;
                            this.createTime = res.data.data.one.ctime.split(".")[0];
                            this.comform1 = true
                            this.Title2 = "处罚详情"
                        }
                    })
                    .catch(() => {
                        this.$message.error('服务器出错，请稍后重试!')
                    })
            },
            showerr(record) {
                this.errorView = true;
                this.errorpagination.id = record.id;
                this.errorpagination.uscc = record.uscc;
                this.errorpagination.wsh = record.wsh;
                this.getErrorList();
            },
            getErrorList() {
                this.errorloading = true;
                console.log(this.errorpagination);
                getErrorList(this.errorpagination).then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == 'FALSE') {
                            this.errorList = [];
                            this.$message.error(res.data.message)
                        } else {
                            this.errorList = res.data.data.page.list;
                            Object.assign(this.errorpagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                current: res.data.data.page.pageNum
                            });
                        }
                    });
                })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    })
                this.errorloading = false;
            },
            errhandleTableChange(page) {
                this.errorpagination.current = page.current;
                this.getErrorList();
            },
            handleChange1(value) {
                this.otherDF = value
                if (value == 9) {
                    this.form.setFieldsValue({
                        otherDesc: ""
                    });
                } else {
                    this.form.setFieldsValue({
                        cfje: "",
                        msje: "",
                        zkbh: ""
                    });
                }
            },
            handleChange2(value) {

                this.hongheiInfo = false;
                this.OtherZtlx = value
                if (value == 1) {
                    this.form.setFieldsValue({
                        zjlx: 1,
                        xzxdrmc: "",
                        // xzxdrmc1: "",
                        zjhm: ""
                    });
                    this.form2.setFieldsValue({
                        zjlx: 1,
                        xzxdrmc: "",
                        // xzxdrmc1: "",
                        zjhm: ""
                    });
                } else {
                    this.form.setFieldsValue({
                        xzxdrmc: "",
                        // xzxdrmc1: "",
                        USCC: "",
                        fddbr: "",
                        fddbrlx: "",
                        fddbrzjh: ""
                    });
                    this.form2.setFieldsValue({
                        xzxdrmc: "",
                        // xzxdrmc1: "",
                        USCC: "",
                        fddbr: "",
                        fddbrlx: "",
                        fddbrzjh: ""
                    });
                }
            },
            compareNUM(rule, value, callback) {
                let reg = /^[0-9.]{0,50}$/;
                if (value && !reg.test(value)) {
                    callback('请输入数字');
                } else {
                    callback();
                }
            },
            changeYXQ1() {
                this.form.setFieldsValue({
                    cfyxq: moment('2099-12-31', "YYYY-MM-DD")
                });
                this.cfyxq1 = "2099-12-31";
            },
            changeJZQ1() {
                this.form.setFieldsValue({
                    cfjzq: moment('2099-12-31', "YYYY-MM-DD")
                });
                this.cfjzq1 = "2099-12-31";
            },
            changeYXQ2() {
                this.form2.setFieldsValue({
                    cfyxq: moment('2099-12-31', "YYYY-MM-DD")
                });
                this.cfyxq1 = "2099-12-31";
            },
            changeJZQ2() {
                this.form2.setFieldsValue({
                    cfjzq: moment('2099-12-31', "YYYY-MM-DD")
                });
                this.cfjzq1 = "2099-12-31";
            },
            disabledDate(current) {
                // Can not select days before today
                return current < (moment().endOf('day') - 24 * 3600 * 1000);
            },
            disabledDate2(current) {
                // Can not select days before today
                return current > (moment().endOf('day'));
            },
            cancelComform2() {
                this.comform1 = false
            },

            publicityValidator2(rule, value, callback){
                let jdrq = this.form2.getFieldValue("jdrq");
              let year = moment(value);
              //moment会自动判断闰年增加
              let _3Year = moment(jdrq);
              if ( year >= _3Year) {
                callback();
              }
              callback("填写日期必须大于等于“处罚决定日期”");
                // console.log(jdrq._d>value._d)
            },
            changeAddOneYear2(){
                let year = this.form2.getFieldValue("jdrq");
                let newYear = moment(year).add(1, 'y').format("YYYY-MM-DD");
                let _1Year = moment((newYear),"YYYY-MM-DD");//获取决定日期+1年
                this.form2.setFieldsValue({
                    cfjzq:_1Year
                })
                this.cfjzq1 = newYear;
            },
            changeAddThreeYear2(){
                let year = this.form2.getFieldValue("jdrq");
                let newYear = moment(year).add(3, 'y').format("YYYY-MM-DD");
                let _3Year = moment((newYear),"YYYY-MM-DD");//获取决定日期+3年
                this.form2.setFieldsValue({
                    cfjzq:_3Year
                })
                this.cfjzq1 = newYear;
            },
            onClose() {
                this.visible = false;
                this.form.resetFields();
                this.form2.resetFields();
                this.upOtherZjlx = false;
                this.otherZjlx = false;
                this.zjlx = 0;
                this.upZjlx = 0;
                this.isUscc2 = false;
            }

        }
    };
</script>

<style scoped lang="less">
    .textTop {
        margin-top: 77px;
    }

    .f14 {
        font-size: 14px;
    }

    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 100%;
        }
    }

    .btns-group {
        text-align: center;
    }

    .btns-group button {
        margin-right: 10px;
    }

    .submit-btn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        background: #fff;
        text-align: right;
    }

    .ant-row > div {
        height: 63px;
    }

    .pjMode-list {
        margin-top: 30px;
    }

    .editable-row-operations a {
        margin-right: 10px;
    }

    .account-info {
        margin-bottom: 10px;
    }

    .auto-label {
        font-size: 14px;
    }

    .auth-list {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 0;
    }

    .menu-top {
        flex-shrink: 0;
        width: 120px;
    }

    .menu-two-item {
        margin: 10px 0;
    }

    .menu-two-item {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }

    .menu-two-top {
        width: 110px;
        flex-shrink: 0;
    }

    .operation-item {
        line-height: 28px;
    }

    .from-top {
        margin-bottom: 30px;
    }

    .from-top2 {
        margin-top: 30px;
    }

    .detail {
        font-size: 18px;
        margin-bottom: 20px;
    }

    .from-inputhei {
        margin-top: -4px;
        height: 32px;
    }


    /*
     *   详情样式
     */
    .bc {
        background-color: #f7f7f7;
    }

    .leftTd {
        width: 19%;
        padding: 9px 10px;
        border: solid 1px #e8e8e8;
        font-size: 13px;
        font-weight: bold;
    }

    .leftTd2 {
        width: 27%;
        padding: 9px 10px;
        border: solid 1px #e8e8e8;
        font-size: 13px;
        font-weight: bold;
    }

    .rightTd {
        width: 31%;
        padding: 9px 10px;
        border: solid 1px #e8e8e8;
        font-size: 12px;
    }

    .rightTd2 {
        width: 73%;
        padding: 9px 10px;
        border: solid 1px #e8e8e8;
        font-size: 12px;
    }
</style>
